import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { AppRouteHelper } from '@app/shared/helpers/app-route.helper';
import { IOperativeUserRole } from '@app/interfaces';

@Injectable({
	providedIn: 'root',
})
export class InsightsOrgGuard implements CanActivate {
	constructor(private router: Router, private featureFlagManager: FeatureFlagManagerService) {}

	public canActivate(next: ActivatedRouteSnapshot): boolean {
		const flags = this.featureFlagManager.flags;
		const isEnabledOptHub = flags[FEATURE_FLAGS.ENABLE_OPTIMIZATION_HUB];
		const isInsightSubscribeOrg =
			!!window.zestyHost?.currentOrganization?.is_managed_insights ||
			window.zestyHost.userRole == IOperativeUserRole.admin;
		if (isEnabledOptHub && !isInsightSubscribeOrg) {
			this.router.navigate([AppRouteHelper.notFound]);
			return false;
		}
		return true;
	}
}
